import FieldTypes from './FieldTypes'

import fieldTypeIcons from './fieldTypeIcons'
import FieldTypeIcon from './FieldTypeIcon'

export {fieldTypeIcons, FieldTypeIcon}
export default FieldTypes
